import { render, staticRenderFns } from "./ListFondosCardClassic.vue?vue&type=template&id=1dd042c0"
import script from "./ListFondosCardClassic.vue?vue&type=script&lang=js"
export * from "./ListFondosCardClassic.vue?vue&type=script&lang=js"
import style0 from "./ListFondosCardClassic.vue?vue&type=style&index=0&id=1dd042c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports